import { useTestExistingSource } from "@prequel/import-react";

import type { TestConnectionResult } from "@/api/client";
import TestConnectionCard from "@/components/TestConnectionCard";
import { useSourceContext } from "@/pages/import/SourcesPage/SourcePage";

// Prepared connections and connection requests are an export-side flow; import sources always
// test with the credentials already stored on the source.
const NO_REQUEST: TestConnectionResult = { status: undefined };

const SourceConnection = () => {
  const { source } = useSourceContext();
  const { execute, result, error, isTesting } = useTestExistingSource();

  // A failed test reports itself two ways: the API answers with an error result, or the call
  // itself fails and useAction leaves `result` undefined. Both have to surface, or the card
  // silently falls back to its idle state.
  const test: TestConnectionResult = isTesting
    ? { status: "processing" }
    : result
      ? { status: result.status, message: result.message }
      : error
        ? { status: "error", message: error.message }
        : { status: undefined };

  return (
    <div className="mt-6">
      <TestConnectionCard
        test={test}
        request={NO_REQUEST}
        connectionType="source"
        usesPreparedConnection={false}
        // execute, not run: run rejects on failure and this has no catch.
        onTestConnection={() => void execute(source.id, undefined)}
      />
    </div>
  );
};

export default SourceConnection;
